import { useState, useEffect, useCallback } from 'react';

const FAVORITES_KEY = 'cinemax_favorites';

export const useFavorites = () => {
  const [favorites, setFavorites] = useState([]);

  // Load favorites from localStorage on mount
  useEffect(() => {
    try {
      const stored = localStorage.getItem(FAVORITES_KEY);
      if (stored) {
        setFavorites(JSON.parse(stored));
      }
    } catch (error) {
      console.error('Error loading favorites:', error);
      setFavorites([]);
    }
  }, []);

  // Save favorites to localStorage whenever they change
  useEffect(() => {
    try {
      localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
    } catch (error) {
      console.error('Error saving favorites:', error);
    }
  }, [favorites]);

  // Add movie to favorites
  const addFavorite = useCallback((movieId) => {
    setFavorites(prev => {
      if (prev.includes(movieId)) return prev;
      return [...prev, movieId];
    });
  }, []);

  // Remove movie from favorites
  const removeFavorite = useCallback((movieId) => {
    setFavorites(prev => prev.filter(id => id !== movieId));
  }, []);

  // Toggle favorite status
  const toggleFavorite = useCallback((movieId) => {
    setFavorites(prev => {
      if (prev.includes(movieId)) {
        return prev.filter(id => id !== movieId);
      }
      return [...prev, movieId];
    });
  }, []);

  // Check if movie is favorite
  const isFavorite = useCallback((movieId) => {
    return favorites.includes(movieId);
  }, [favorites]);

  return {
    favorites,
    addFavorite,
    removeFavorite,
    toggleFavorite,
    isFavorite,
  };
};

export default useFavorites;
